// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.radio-single-container {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.radio-single-container .radio-label {
  margin-left: 8px;
}
.radio-single-container input[type=radio] {
  transform: scale(1.2);
}

.highlight {
  background: #FEBF31;
  background: rgb(252, 209, 17);
  color: black;
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 18px;
}

.column-header-button-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 40px;
}
.column-header-button-container .sort-buttons-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 30px;
  width: 30px;
}
.column-header-button-container .sort-buttons-container button {
  border-radius: 5px;
  border: none;
  background: none;
  display: flex;
  align-items: center;
  height: 12px;
}
.column-header-button-container .sort-buttons-container button:hover {
  transform: scale(1.3);
  border: 1px solid white;
}

.overall-reprocess-container {
  margin-bottom: 30px;
}
.overall-reprocess-container .search-container {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}
.overall-reprocess-container .search-container label {
  color: #0669B3;
  font-weight: 500;
  font-size: 14px;
}
.overall-reprocess-container .search-container .input-container {
  display: flex;
  align-items: center;
}
.overall-reprocess-container .search-container .input-container input {
  width: 350px;
}

.found-text-container {
  display: flex;
  margin-bottom: 20px;
}
.found-text-container .found-text-large {
  font-weight: 600;
  font-size: 20px;
  color: #0669B3;
  margin-right: 20px;
}
.found-text-container .found-text {
  border-radius: 5px;
  background: #C0DEF0;
  font-weight: 600;
  font-size: 16px;
  padding: 5px 20px;
}

.main-container-titlebar {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 550;
  height: 40px;
  padding-left: 20px;
  margin: 0 auto;
  background: #FDF9D0;
}

.info-container {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  display: flex;
  margin: 0 auto;
  background: #FDF9D0;
}
.info-container .more-info {
  font-weight: 600;
}
.info-container .more-info span {
  margin-left: 10px;
  font-weight: 500;
  color: #0669B3;
}
.info-container .left-container {
  padding: 10px 30px;
  margin-right: 50px;
}
.info-container .right-container {
  padding: 10px 30px;
}

.sorry {
  font-size: 18px;
  font-weight: 500;
}

@media only screen and (max-width: 1450px) {
  .found-text-container {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/Reprocess.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAUJ;AARI;EACI,gBAAA;AAUR;AARI;EACI,qBAAA;AAUR;;AAPA;EACI,mBDIQ;ECHR,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAUJ;;AARA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAWJ;AATI;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAWR;AATQ;EClCJ,kBDmC8B;EACtB,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAWZ;AATY;EACI,qBAAA;EACA,uBAAA;AAWhB;;AAJA;EACI,mBAAA;AAOJ;AALI;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;AAOR;AANQ;EACI,cD/BC;ECgCD,gBAAA;EACA,eAAA;AAQZ;AANQ;EACI,aAAA;EACA,mBAAA;AAQZ;AAPY;EACI,YAAA;AAShB;;AAHA;EACI,aAAA;EACA,mBAAA;AAMJ;AALI;EACI,gBAAA;EACA,eAAA;EACA,cDnDK;ECoDL,kBAAA;AAOR;AALI;EClFA,kBDmF0B;EACtB,mBDzDI;EC0DJ,gBAAA;EACA,eAAA;EACA,iBAAA;AAOR;;AAHA;EACQ,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,mBDrFI;AC2FZ;;AAJA;EACI,8BAAA;EACA,+BAAA;EACA,aAAA;EACA,cAAA;EACA,mBD5FQ;ACmGZ;AANI;EACI,gBAAA;AAQR;AAPQ;EACI,iBAAA;EACA,gBAAA;EACA,cDtFC;AC+Fb;AANI;EACI,kBAAA;EACA,kBAAA;AAQR;AANI;EACI,kBAAA;AAQR;;AAJA;EACI,eAAA;EACA,gBAAA;AAOJ;;AAHA;EACI;IACI,cAAA;EAMN;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$dk-blue: #19608f;\n$dashboard-blue: #0d6efd;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n// $DCSD-logo-green: #84ae30; // old - does not pass\n// $DCSD-logo-green: #94B741; // this is the color from district site (see kellys screen shot)\n$DCSD-logo-green: #577d00; // darker green but does pass in FF\n$text: #414042;\n$white: #EDEDED;\n$shadow: #818181;\n$shadow2: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey0b: #e8e8e8; // new grey color\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$accessibility-red: rgb(218, 18, 18);\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.radio-single-container {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n    \n    .radio-label {\n        margin-left: 8px;\n    }\n    input[type=\"radio\"] {\n        transform: scale(1.2);\n    }\n}\n.highlight {\n    background: $important;\n    background: rgb(252, 209, 17);\n    color: black;\n    padding: 1px 6px;\n    border-radius: 3px;\n    font-size: 18px;\n}\n.column-header-button-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-height: 40px;\n\n    .sort-buttons-container {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        align-items: center;\n        height: 30px;\n        width: 30px;\n        \n        button {\n            @include borderRadius(5px);\n            border: none;\n            background: none;\n            display: flex;\n            align-items: center;\n            height: 12px;\n\n            &:hover {\n                transform: scale(1.300);\n                border: 1px solid white;\n            }\n        }\n    }\n\n}\n\n.overall-reprocess-container {\n    margin-bottom: 30px;\n    \n    .search-container {\n        margin-top: 20px;\n        display: flex;\n        flex-direction: column;\n        label {\n            color: $pearl-blue;\n            font-weight: 500;\n            font-size: 14px;\n        }\n        .input-container {\n            display: flex;\n            align-items: center;\n            input {\n                width: 350px;\n            }\n        }\n    }\n}\n\n.found-text-container {\n    display: flex;\n    margin-bottom: 20px;\n    .found-text-large {\n        font-weight: 600;\n        font-size: 20px;\n        color: $pearl-blue;\n        margin-right: 20px;\n    }\n    .found-text {\n        @include borderRadius(5px);\n        background: $pale-blue;\n        font-weight: 600;\n        font-size: 16px;\n        padding: 5px 20px\n    }\n}\n\n.main-container-titlebar {\n        border-top-left-radius: 5px;\n        border-top-right-radius: 5px;\n        display: flex;\n        align-items: center;\n        font-size: 16px;\n        font-weight: 550;\n        height: 40px;\n        padding-left: 20px;\n        margin: 0 auto;\n        background: $highlight;\n    }\n.info-container {\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n    display: flex;\n    margin:0 auto;\n    background: $highlight;\n    .more-info {\n        font-weight: 600;\n        span {\n            margin-left: 10px;\n            font-weight: 500;\n            color: $pearl-blue;\n        }\n    }\n    .left-container {\n        padding: 10px 30px;\n        margin-right: 50px;\n    }\n    .right-container {\n        padding: 10px 30px;\n    }\n}\n\n.sorry { \n    font-size: 18px;\n    font-weight: 500;\n}\n\n// mobile \n@media only screen and (max-width: 1450px) {\n    .found-text-container {\n        display: block;\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
